import * as React from 'react';
import Link from '@material-ui/core/Link';
import LaunchIcon from '@material-ui/icons/Launch';

interface Props {
  url: string,
  label: string
}

/** フッターの外部リンクのコンポーネント。 */
const ExternalLink: React.FC<Props> = (props: Props) => {
  return (
      <Link
        target='_blank'
        href={props.url}
        color='inherit'
      >
        {props.label}
        <LaunchIcon style={{ fontSize: '14px', marginLeft: 1, verticalAlign: 'middle' }}/>
      </Link>
  )
};

export default ExternalLink;
